import logger from 'logger'
import analyticsWrapper from '../wrapper'
import { getAnalyticsContext } from '../context'


type Event = 'setUserId' | 'trackPageView' | 'trackSelfDescribingEvent'

declare global {
  interface Window {
    snowplow: (event: Event, ...args: any[]) => void
  }
}

type Params = {
  page?: string
  pageType?: string
  [k: string]: string | number | boolean
}

type Events = Analytics.SnowplowEvents & Analytics.Events

type Methods = {
  setUserId: (userId: any) => void
  trackPageView: (pathname: string, params: Params) => void
  track: Analytics.TrackFunction<Events>
}


const snowplow = analyticsWrapper<Methods>({
  entityKey: 'snowplow',
  // wait for snowplow initialization. partytownThirdPartyScriptLoaded flag is available only when snowplow is initialized
  entityResolver: () => window.partytownThirdPartyScriptLoaded?.['SNOWPLOW'],
  resolveMethods: {
    setUserId: (userId: any) => {
      window.snowplow('setUserId', userId)
    },
    trackPageView: (pathname: string, params: Params) => {
      const properties = {
        ...getAnalyticsContext(),
        ...params,
      }

      logger.info(`[Snowplow] trackPageView`, {
        extra: {
          pathname,
          properties,
        },
      })

      window.snowplow('trackPageView', {
        title: pathname,
        context: [
          {
            // https://github.com/scentbird/event-processor/blob/master/snowplow/IgluCentral/schemas/com.scentbird/pageviews/jsonschema/1-0-0
            schema: 'iglu:com.scentbird/pageviews/jsonschema/1-0-0',
            data: properties,
          },
        ],
      })
    },
    track: (eventName, params) => {
      const properties = {
        ...getAnalyticsContext(),
        ...params,
      }

      logger.info(`[Snowplow] track ${eventName}`, {
        extra: {
          properties,
        },
      })

      window.snowplow('trackSelfDescribingEvent', {
        event: {
          schema: 'iglu:com.scentbird/freestyle/jsonschema/1-0-0',
          data: {
            eventName,
            properties: JSON.stringify(properties),
          },
        },
      })
    },
  },
})


export default snowplow
